'use client'

import React, { forwardRef } from 'react'
import classNames from 'classnames'
import { useTilt } from './index'

type Props = React.HTMLAttributes<HTMLDivElement> & { enabled?: boolean }

/**
 * A card that tilts toward the cursor (perspective rotate, ±8°) and presses
 * down on click. With `enabled` false it is a plain div, so callers can keep
 * one markup path for bitmap and non-bitmap grids.
 */
const TiltCard = forwardRef<HTMLDivElement, Props>(function TiltCard(
	{ enabled = true, className, style, onMouseMove, onMouseLeave, children, ...rest },
	ref
) {
	const tilt = useTilt(8)
	if (!enabled) {
		return (
			<div
				ref={ref}
				className={className}
				style={style}
				onMouseMove={onMouseMove}
				onMouseLeave={onMouseLeave}
				{...rest}
			>
				{children}
			</div>
		)
	}
	return (
		<div
			ref={ref}
			className={classNames(className, 'will-change-transform active:scale-[0.97]')}
			style={{ ...style, ...tilt.style }}
			onMouseMove={(e) => {
				tilt.onMouseMove(e)
				onMouseMove?.(e)
			}}
			onMouseLeave={(e) => {
				tilt.onMouseLeave()
				onMouseLeave?.(e)
			}}
			{...rest}
		>
			{children}
		</div>
	)
})

export default TiltCard
